;(function ($, window, document) {
  function onDOMContentLoaded() {
    var productList = '.js-product-list',
        productContainer = '.js-product-container';

    $(productList).on('click', productContainer, function (event) {
      var isOpen = $(event.currentTarget).hasClass('open');
      // Close other possibly open product boxes
      $(productContainer + '.open').removeClass('open');
      $(event.currentTarget).toggleClass('open', !isOpen);
    });

    $(productContainer).on('click', 'a', function (event) {
      event.stopImmediatePropagation();
    });
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }

})(jQuery, window, document);
